import { render } from "./TestDescription.vue?vue&type=template&id=4fc11068&scoped=true"
import script from "./TestDescription.vue?vue&type=script&lang=js"
export * from "./TestDescription.vue?vue&type=script&lang=js"

import "./TestDescription.vue?vue&type=style&index=0&id=4fc11068&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc11068"]])

export default __exports__